/* eslint-disable no-template-curly-in-string */
import React, { useState } from "react";
import { Form, message } from "antd";

import StateForm from "./StateForm";

const AddState = (props) => {
  const {
    addState,
    states,
    telemedicineCategory,
    consultationType,
    listOfPharmacies,
    fetchPharmacies,
    pharmacyLoading,
    onCancel,
  } = props;
  const [addedTeleMedicineCategory, setAddedTeleMedicineCategory] = useState(
    []
  );

  const [form] = Form.useForm();
  const onFinish = async (values) => {
    const { state, pdmpResource, oneClickPrescribeEligible } = values;
    const { stateName } = state;
    if (!addedTeleMedicineCategory.length) {
      return false;
    }
    if (oneClickPrescribeEligible) {
      window.alert("Ensure desired telemedicine category is also configured for Clinical Eligibility Validator");
    }

    const consultationTypeDetails = addedTeleMedicineCategory.map(
      (eachCategory) => ({
        categoryId: eachCategory.categoryId,
        categoryName: eachCategory.categoryName,
        consultationType: eachCategory.consultationType,
      })
    );

    const pharmacyDetails = addedTeleMedicineCategory.map((eachCategory) => ({
      categoryId: eachCategory.categoryId,
      pharmacyName: eachCategory.pharmacyName,
      pharmacyId: eachCategory.pharmacyId,
    }));

    const stateDetails = {
      name: stateName,
      consultationType: [...consultationTypeDetails],
      pharmacy: [...pharmacyDetails],
      pdmpResource,
      oneClickPrescribeEligible
    };

    try {
      await addState(stateDetails)
      form.resetFields()
      setAddedTeleMedicineCategory([]);
      message.success("Successfully Added State");
    } catch (e) {
      message.error(e.message)
    }
  };

  return (
    <StateForm
      mode="add"
      form={form}
      onFinish={onFinish}
      states={states}
      telemedicineCategory={telemedicineCategory}
      consultationType={consultationType}
      listOfPharmacies={listOfPharmacies}
      fetchPharmacies={fetchPharmacies}
      pharmacyLoading={pharmacyLoading}
      addedTeleMedicineCategory={addedTeleMedicineCategory}
      setAddedTeleMedicineCategory={setAddedTeleMedicineCategory}
      onCancel={onCancel}
    />
  );
};

export default AddState;
